// external-script.js
var scriptExists = document.head.querySelector('script[src="https://storage.googleapis.com/assets-live2ai-prod/assets/social-wall-sdk/latest/live2ai-embed-sdk.js"]') !== null;

if (!scriptExists) {
    var script = document.createElement("script");
    script.src = "https://cdn.live2.ai/assets/social-wall-sdk/latest/live2ai-embed-sdk.js";
    script.defer = true;

    // Append the script element to the document's head
    document.head.appendChild(script);
}












